import styled from "@emotion/styled";
import { Button, Card, Row, Typography } from "antd";
import { goBack, menuProduct, bookBank, memuSetting, shipping, MenuShipping, memuContact, money, locationIcon, locationCircle, menuCampaign, guardKey, factory, exchangePoint, boxIcon } from "assets/icons/index";
import { useNavigate } from "react-router-dom";

import CardMenuProfile from "../Profiles/CardMenuProfile";
import { setReload } from "store/slices/orderSlice";
import { useAppDispatch } from "store";
import { Newspaper } from "@mui/icons-material";
import { useAppSelector } from "store";


const Setting = () => {

  const { contact } = useAppSelector((state) => state.auth);

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const sectionOne = [
    {
      title: "สินค้าและสต็อก",
      icon: menuProduct,
      func: () => {
        navigate("/manage-product");
      },
    },
    {
      title: "คลังสินค้า",
      icon: boxIcon,
      func: () => {
        navigate("/warehouse");
      },
    },
    {
      title: "ข่าวสารและโปรโมชั่น",
      icon: menuCampaign,
      func: () => {
        navigate("/campaign");
      },
    },

    {
      title: "บัญชีธนาคารของฉัน",
      icon: bookBank,
      func: () => {
        navigate("/manage-bank");
      },
    },

    ...(contact?.code === "lunganek" ? [
      {
        title: "จัดการขนส่ง",
        icon: MenuShipping,
        func: () => {
          navigate("/manage-transportation");
        },
      },
    ] : []),
    ...(contact?.code === "lunganek" ? [
      {
        title: "จัดการจุดจอด",
        icon: locationCircle,
        func: () => {
          navigate("/delivery-point");
        },
      },
    ] : []),
    ...(contact?.code === "lunganek" ? [
      {
        title: "จัดการค่าจัดส่ง",
        icon: money,
        func: () => {
          navigate("/manage-shipping");
        },
      },
    ] : []),
    // {
    //   title: "ตั้งค่า Line Application",
    //   icon: memuSetting,
    //   func: () => {
    //     navigate("/profiles/setting-line-alert")
    //   },
    // },
    {
      title: "ตั้งค่าที่อยู่รับสินค้า",
      icon: locationCircle,
      func: () => {
        navigate("/manage-merchant");
      },
    },
    {
      title: "ตั้งค่ากิจการ",
      icon: factory,
      func: () => {
        navigate("/profiles/setting-factory");
      },
    },
    {
      title: "ผู้ใช้งานระบบ",
      icon: guardKey,
      func: () => {
        navigate("/profiles/user-system");
      },
    },
    ...(contact?.code === "lunganek" ? [
      {
        title: "ตั้งค่าการเติม Point",
        icon: exchangePoint,
        func: () => {
          navigate("/setting-point");
        },
      },
    ] : []),
    ...(contact?.code === "lunganek" ? [
      {
        title: "ตั้งค่ากล่อง",
        icon: boxIcon,
        func: () => {
          navigate("/setting-box");
        },
      },
    ] : []),
  ];

  return (
    <>

      <Card bordered={false} className="criclebox h-full tabs-mobile">
        <HeaderTabs>
          <IconWrapper
            onClick={() => {
              navigate("/dashboard");
            }}
          >
            <SpanIcon>{goBack}</SpanIcon>
          </IconWrapper>
          <Typography.Title level={5}>ตั้งค่าร้านค้า</Typography.Title>
          <RightIconWrapper>
          </RightIconWrapper>
        </HeaderTabs>
        <Row
          gutter={[8, 0]}
          style={{
            backgroundColor: "#EFEFEF",
            overflow: "auto",
            padding: "10px 0px 0px 0px",
          }}
        >
          {sectionOne.map((item, index) => {
            return (
              <CardMenuProfile
                key={index}
                title={item.title}
                icon={item.icon}
                func={item.func}
              />
            );
          })}
        </Row>
      </Card>
    </>
  );
};

export default Setting;

const HeaderTabs = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  flex-direction: row;
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 30px;
  border-radius: 6px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #efefef;
  }
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const RightIconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;
